module.exports = __webpack_public_path__ + "static/images/ad.1f129e7.jpg";